// Valida el rut com formato "XXXXXXXX-X"
export default (fullRut) => {
  fullRut = fullRut.replaceAll('.', '');
  if (fullRut.length < 8) {
    return false
  }
  if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(fullRut))
    return false;
  let tmp 	= fullRut.split('-');
  let digv	= tmp[1]; 
  let rut 	= tmp[0];
  if ( digv == 'K' ) digv = 'k';

  let M=0,S=1;
  for(;rut;rut=Math.floor(rut/10))
    S=(S+rut%10*(9-M++%6))%11;

  return (S?S-1:'k') == digv;
}